import React from 'react';
import classNames from 'classnames';

/**
 * Render a simple item corresponding to boxes availaibilities.
 */
class BoxAvailability extends React.Component {
    render() {
        const { room } = this.props;

        return (
            <div
                className={classNames(
                    'meeting-room--box',
                    'meeting-room__availability',
                    'meeting-room-availability'
                )}
            >
                <div className="meeting-room-availability__label">
                    {room.label}
                </div>
                <div className="meeting-room__box meeting-room-box">
                    {room.availabilities.map((box, index) => (
                        <div
                            key={index}
                            className={classNames(
                                'meeting-room-box__availability',
                                box.type === 'FREE' &&
                                    'meeting-room-availability--free',
                                box.type === 'SOON' &&
                                    'meeting-room-availability--soon',
                                box.type === 'OCCUPIED' &&
                                    'meeting-room-availability--occupied'
                            )}
                        >
                            <div className="meeting-room-availability__label">
                                {box.label}
                            </div>
                            <div className="meeting-room-availability__bullet" />
                            {box.type !== 'OCCUPIED' && (
                                <div className="meeting-room-availability__time">
                                    {box.time > 60 ? '+1H' : box.time + 'min'}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

export default BoxAvailability;



// WEBPACK FOOTER //
// ./src/components/MeetingRoom/BoxAvailability.js